module.exports = __webpack_public_path__ + "static/media/Macbook5.7b9ed3e6.png";